export enum RelationStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  DEACTIVATED = 'DEACTIVATED',
  SUSPENDED = 'SUSPENDED',
  DELETED = 'DELETED',
}

export const RelationStatusLabels: Record<RelationStatus, string> = {
  [RelationStatus.ACTIVE]: 'Conectado',
  [RelationStatus.INACTIVE]: 'No Conectado',
  [RelationStatus.DEACTIVATED]: 'Desconectado',
  [RelationStatus.SUSPENDED]: 'Por Eliminar',
  [RelationStatus.DELETED]: 'Eliminado',
};

export interface BusinessRelation {
  businessName: string;
  id: string;
  identifier: string;
  active: boolean;
  createdAt: Date;
  lastExtraction: Date | null;
  pausedAt: Date | null;
  deactivatedAt: Date | null;
  activatedAt: Date | null;
  enrolledBy?: string | null;
  enrolledPath?: string | null;
  users?: string;
  status: RelationStatus;
  statusLabel: string;
  isBotGenerated: boolean;
}

export interface RelationsByStatus {
  [RelationStatus.ACTIVE]: BusinessRelation[];
  [RelationStatus.INACTIVE]: BusinessRelation[];
  [RelationStatus.DEACTIVATED]: BusinessRelation[];
  [RelationStatus.SUSPENDED]: BusinessRelation[];
  [RelationStatus.DELETED]: BusinessRelation[];
}

export interface RelationsStats {
  [RelationStatus.ACTIVE]: number;
  [RelationStatus.INACTIVE]: number;
  [RelationStatus.DEACTIVATED]: number;
  [RelationStatus.SUSPENDED]: number;
  [RelationStatus.DELETED]: number;
  total: number;
}

export interface PaginationInfo {
  total: number;
  page: number;
  pageSize: number;
  totalPages: number;
}

export interface BusinessRelationsResponse {
  relations: BusinessRelation[];
  stats: RelationsStats;
  pagination: PaginationInfo;
}
